function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { defineElements } from '@lumieducation/h5p-webcomponents';
defineElements('h5p-editor');

var H5PEditorUI = /*#__PURE__*/function (_React$Component) {
  _inherits(H5PEditorUI, _React$Component);

  var _super = _createSuper(H5PEditorUI);

  function H5PEditorUI(props) {
    var _this;

    _classCallCheck(this, H5PEditorUI);

    _this = _super.call(this, props);

    _this.loadContentCallbackWrapper = function (contentId) {
      return _this.props.loadContentCallback(contentId);
    };

    _this.onEditorLoaded = function (event) {
      if (_this.props.onLoaded) {
        _this.props.onLoaded(event.detail.contentId, event.detail.ubername);
      }
    };

    _this.onSaved = function (event) {
      if (_this.props.onSaved) {
        _this.props.onSaved(event.detail.contentId, event.detail.metadata);
      }
    };

    _this.onSaveError = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.props.onSaveError) {
                  _this.props.onSaveError(event.detail.message);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.saveContentCallbackWrapper = function (contentId, requestBody) {
      return _this.props.saveContentCallback(contentId, requestBody);
    };

    _this.h5pEditor = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(H5PEditorUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerEvents();
      this.setServiceCallbacks();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _a;

      this.registerEvents();
      this.setServiceCallbacks();
      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterEvents();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      // Should the old editor instance be destroyed, we unregister from it...
      this.unregisterEvents();
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("h5p-editor", {
        ref: this.h5pEditor,
        "content-id": this.props.contentId
      });
    }
    /**
     * Call this method to save the current state of the h5p editor. This will
     * result in a call to the `saveContentCallback` that was passed in the
     * through the props.
     * @throws an error if there was a problem (e.g. validation error of the
     * content)
     */

  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.save();

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _a, _b, _c, _d;

      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.addEventListener('saved', this.onSaved);
      (_b = this.h5pEditor.current) === null || _b === void 0 ? void 0 : _b.addEventListener('editorloaded', this.onEditorLoaded);
      (_c = this.h5pEditor.current) === null || _c === void 0 ? void 0 : _c.addEventListener('save-error', this.onSaveError);
      (_d = this.h5pEditor.current) === null || _d === void 0 ? void 0 : _d.addEventListener('validation-error', this.onSaveError);
    }
  }, {
    key: "setServiceCallbacks",
    value: function setServiceCallbacks() {
      if (this.h5pEditor.current) {
        this.h5pEditor.current.loadContentCallback = this.loadContentCallbackWrapper;
        this.h5pEditor.current.saveContentCallback = this.saveContentCallbackWrapper;
      }
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      var _a, _b, _c, _d;

      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('saved', this.onSaved);
      (_b = this.h5pEditor.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('editorloaded', this.onEditorLoaded);
      (_c = this.h5pEditor.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('save-error', this.onSaveError);
      (_d = this.h5pEditor.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('validation-error', this.onSaveError);
    }
  }]);

  return H5PEditorUI;
}(React.Component);

export { H5PEditorUI as default };